import request from '@/router/axios'

const baseAnswerUrl = 'http://47.92.102.238:8080/exercise/'
// const baseAnswerUrl = 'http://api.exam.chineseall.cn:8081/exercise/'

const requestApi = ({ url, method, params }) => {
  return new Promise(async (resovle, reject) => {
    const res = await request({
      url: baseAnswerUrl + url,
      method,
      params
    })
    if (res.data && res.data.code == 200)
    {
      resovle(res.data.data)
    } else
    {
      reject(res.data.msg)
    }
  })
}

// 获取消息列表
export const getMessageList = data => requestApi({
  url: 'message/list',
  method: 'get',
  params: data
})


// 获取未读消息数量
export const unreadReadCount = data => requestApi({
  url: 'message/unreadReadCount',
  method: 'get',
  params: data
})

// 设置消息为已读
export const updateStatus = (id) => requestApi({
  url: `message/updateStatus/${id}`,
  method: 'put'
})

// 一键已读
export const unreadAllReadCount = () => requestApi({
  url: 'message/unreadAllReadCount',
  method: 'put'
})


// 根据id查看赛事
export const getCompetitionDetail = id => requestApi({
  url: `competition/getCompetitionDetail/${id}`,
  method: 'get',
})


// 报名
export const registrationCompetition = id => requestApi({
  url: `competition/registrationCompetition/${id}`,
  method: 'get',
})

// 根据联赛获取联赛详情
export const leagueDetail = id => requestApi({
  url: `league/get/${id}`,
  method: 'get',
})

// 我的报名列表
export const competitionList = data => requestApi({
  url: `competition/listCompetitionDetail`,
  method: 'get',
  params: data
})

// 我的成绩
export const getScore = competitionId => requestApi({
  url: `competition/getScore/${competitionId}`,
  method: 'get',
})

// 答题记录列表
export const listCompetition = (data) => requestApi({
  url: 'competition/listCompetition',
  method: 'get',
  params:data
})


// 检查赛事是否已可以开始答题
export const checkCanStart = competitionId => requestApi({
  url: `competition/checkCanStart/${competitionId}`,
  method: 'get',
})



// WEBPACK FOOTER //
// ./src/api/competition/index.js